var ENV = "prod"; // 控制开关,dev 开发环境，release,master环境时改为prod
export default {
  pathUrl () {
    var URLS = {
      dev: {
        MJK: '/apis',
        WEB_URL: {
          WEB_MIAO: 'http://test.customer.adxiaoguo.com'
        }
      },
      prod: {
        MJK: '',
        WEB_URL: {
          WEB_MIAO: 'http://test.customer.adxiaoguo.com'
        }
      }
    }
    return URLS[ENV];
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js